import { Directive, EventEmitter, Host, Injectable, Output, Self, ViewContainerRef } from "@angular/core";
import { Route } from "@angular/router";

export function getRouteRoles(route: Route): string[] {
    return route.data ? route.data['roles'] as string[] || [] : [];
}

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    private static container: ViewContainerRef;
    set container(container: ViewContainerRef) {
        MenuService.container = container;
    }
    get container(): ViewContainerRef {
        return MenuService.container;
    }

    private _menuItems: Map<string, Route[]> = new Map<string, Route[]>();

    @Output() menuItemsChanged: EventEmitter<void> = new EventEmitter<void>();

    getMenuItems(module: string): Route[] {
        return this._menuItems.get(module) || [];
    }

    getSecureMenuItems(module: string, roles: string[]): Route[] {
        let items = this._menuItems.get(module) || [];
        return items.filter((item) => {
            if (item.data) {
                let menuRoles = getRouteRoles(item);
                if (menuRoles != null && menuRoles.length > 0) {
                    for (let menuRole of menuRoles) {
                        if (!roles.includes(menuRole)) {
                            return false;
                        }
                    }
                }
            }
            return true;
        });
    }

    setMenuItems(module: string, items: Route[]) {
        this._menuItems.set(module, items);
        this.menuItemsChanged.emit();
    }
}

@Directive({
    selector: 'sideNavContainer',
    standalone: false
})
export class SideMenuDirective {
    constructor(@Host() @Self() sideNavContainer: ViewContainerRef, menuService: MenuService) {
        menuService.container = sideNavContainer;
    }
}